import { getSupportedCurrencies } from 'currency-denominations';

/**
 * Currency metadata (name and symbol) for ISO 4217 codes
 * Symbols are the most commonly used representation for each currency
 */
const CURRENCY_METADATA = {
    AED: { name: 'UAE Dirham', symbol: 'د.إ' },
    AFN: { name: 'Afghan Afghani', symbol: '؋' },
    ALL: { name: 'Albanian Lek', symbol: 'L' },
    AMD: { name: 'Armenian Dram', symbol: '֏' },
    ANG: { name: 'Netherlands Antillean Guilder', symbol: 'ƒ' },
    AOA: { name: 'Angolan Kwanza', symbol: 'Kz' },
    ARS: { name: 'Argentine Peso', symbol: '$' },
    AUD: { name: 'Australian Dollar', symbol: 'A$' },
    AWG: { name: 'Aruban Florin', symbol: 'ƒ' },
    AZN: { name: 'Azerbaijani Manat', symbol: '₼' },
    BAM: { name: 'Bosnia-Herzegovina Convertible Mark', symbol: 'KM' },
    BBD: { name: 'Barbadian Dollar', symbol: 'Bds$' },
    BDT: { name: 'Bangladeshi Taka', symbol: '৳' },
    BGN: { name: 'Bulgarian Lev', symbol: 'лв' },
    BHD: { name: 'Bahraini Dinar', symbol: '.د.ب' },
    BIF: { name: 'Burundian Franc', symbol: 'FBu' },
    BMD: { name: 'Bermudan Dollar', symbol: '$' },
    BND: { name: 'Brunei Dollar', symbol: 'B$' },
    BOB: { name: 'Bolivian Boliviano', symbol: 'Bs.' },
    BRL: { name: 'Brazilian Real', symbol: 'R$' },
    BSD: { name: 'Bahamian Dollar', symbol: 'B$' },
    BTN: { name: 'Bhutanese Ngultrum', symbol: 'Nu.' },
    BWP: { name: 'Botswanan Pula', symbol: 'P' },
    BYN: { name: 'Belarusian Ruble', symbol: 'Br' },
    BZD: { name: 'Belize Dollar', symbol: 'BZ$' },
    CAD: { name: 'Canadian Dollar', symbol: 'C$' },
    CDF: { name: 'Congolese Franc', symbol: 'FC' },
    CHF: { name: 'Swiss Franc', symbol: 'CHF' },
    CLP: { name: 'Chilean Peso', symbol: '$' },
    CNY: { name: 'Chinese Yuan', symbol: '¥' },
    COP: { name: 'Colombian Peso', symbol: '$' },
    CRC: { name: 'Costa Rican Colón', symbol: '₡' },
    CUC: { name: 'Cuban Convertible Peso', symbol: 'CUC$' },
    CUP: { name: 'Cuban Peso', symbol: '₱' },
    CVE: { name: 'Cape Verdean Escudo', symbol: '$' },
    CZK: { name: 'Czech Koruna', symbol: 'Kč' },
    DJF: { name: 'Djiboutian Franc', symbol: 'Fdj' },
    DKK: { name: 'Danish Krone', symbol: 'kr' },
    DOP: { name: 'Dominican Peso', symbol: 'RD$' },
    DZD: { name: 'Algerian Dinar', symbol: 'د.ج' },
    EGP: { name: 'Egyptian Pound', symbol: 'E£' },
    ERN: { name: 'Eritrean Nakfa', symbol: 'Nfk' },
    ETB: { name: 'Ethiopian Birr', symbol: 'Br' },
    EUR: { name: 'Euro', symbol: '€' },
    FJD: { name: 'Fijian Dollar', symbol: 'FJ$' },
    FKP: { name: 'Falkland Islands Pound', symbol: '£' },
    GBP: { name: 'British Pound', symbol: '£' },
    GEL: { name: 'Georgian Lari', symbol: '₾' },
    GHS: { name: 'Ghanaian Cedi', symbol: 'GH₵' },
    GIP: { name: 'Gibraltar Pound', symbol: '£' },
    GMD: { name: 'Gambian Dalasi', symbol: 'D' },
    GNF: { name: 'Guinean Franc', symbol: 'FG' },
    GTQ: { name: 'Guatemalan Quetzal', symbol: 'Q' },
    GYD: { name: 'Guyanaese Dollar', symbol: 'G$' },
    HKD: { name: 'Hong Kong Dollar', symbol: 'HK$' },
    HNL: { name: 'Honduran Lempira', symbol: 'L' },
    HRK: { name: 'Croatian Kuna', symbol: 'kn' },
    HTG: { name: 'Haitian Gourde', symbol: 'G' },
    HUF: { name: 'Hungarian Forint', symbol: 'Ft' },
    IDR: { name: 'Indonesian Rupiah', symbol: 'Rp' },
    ILS: { name: 'Israeli New Shekel', symbol: '₪' },
    INR: { name: 'Indian Rupee', symbol: '₹' },
    IQD: { name: 'Iraqi Dinar', symbol: 'ع.د' },
    IRR: { name: 'Iranian Rial', symbol: '﷼' },
    ISK: { name: 'Icelandic Króna', symbol: 'kr' },
    JMD: { name: 'Jamaican Dollar', symbol: 'J$' },
    JOD: { name: 'Jordanian Dinar', symbol: 'د.ا' },
    JPY: { name: 'Japanese Yen', symbol: '¥' },
    KES: { name: 'Kenyan Shilling', symbol: 'KSh' },
    KGS: { name: 'Kyrgystani Som', symbol: 'с' },
    KHR: { name: 'Cambodian Riel', symbol: '៛' },
    KMF: { name: 'Comorian Franc', symbol: 'CF' },
    KPW: { name: 'North Korean Won', symbol: '₩' },
    KRW: { name: 'South Korean Won', symbol: '₩' },
    KWD: { name: 'Kuwaiti Dinar', symbol: 'د.ك' },
    KYD: { name: 'Cayman Islands Dollar', symbol: 'CI$' },
    KZT: { name: 'Kazakhstani Tenge', symbol: '₸' },
    LAK: { name: 'Laotian Kip', symbol: '₭' },
    LBP: { name: 'Lebanese Pound', symbol: 'ل.ل' },
    LKR: { name: 'Sri Lankan Rupee', symbol: 'Rs' },
    LRD: { name: 'Liberian Dollar', symbol: 'L$' },
    LSL: { name: 'Lesotho Loti', symbol: 'L' },
    LYD: { name: 'Libyan Dinar', symbol: 'ل.د' },
    MAD: { name: 'Moroccan Dirham', symbol: 'د.م.' },
    MDL: { name: 'Moldovan Leu', symbol: 'L' },
    MGA: { name: 'Malagasy Ariary', symbol: 'Ar' },
    MKD: { name: 'Macedonian Denar', symbol: 'ден' },
    MMK: { name: 'Myanmar Kyat', symbol: 'K' },
    MNT: { name: 'Mongolian Tugrik', symbol: '₮' },
    MOP: { name: 'Macanese Pataca', symbol: 'MOP$' },
    MRU: { name: 'Mauritanian Ouguiya', symbol: 'UM' },
    MUR: { name: 'Mauritian Rupee', symbol: '₨' },
    MVR: { name: 'Maldivian Rufiyaa', symbol: 'Rf' },
    MWK: { name: 'Malawian Kwacha', symbol: 'MK' },
    MXN: { name: 'Mexican Peso', symbol: 'Mex$' },
    MYR: { name: 'Malaysian Ringgit', symbol: 'RM' },
    MZN: { name: 'Mozambican Metical', symbol: 'MT' },
    NAD: { name: 'Namibian Dollar', symbol: 'N$' },
    NGN: { name: 'Nigerian Naira', symbol: '₦' },
    NIO: { name: 'Nicaraguan Córdoba', symbol: 'C$' },
    NOK: { name: 'Norwegian Krone', symbol: 'kr' },
    NPR: { name: 'Nepalese Rupee', symbol: 'रू' },
    NZD: { name: 'New Zealand Dollar', symbol: 'NZ$' },
    OMR: { name: 'Omani Rial', symbol: 'ر.ع.' },
    PAB: { name: 'Panamanian Balboa', symbol: 'B/.' },
    PEN: { name: 'Peruvian Sol', symbol: 'S/' },
    PGK: { name: 'Papua New Guinean Kina', symbol: 'K' },
    PHP: { name: 'Philippine Peso', symbol: '₱' },
    PKR: { name: 'Pakistani Rupee', symbol: '₨' },
    PLN: { name: 'Polish Zloty', symbol: 'zł' },
    PYG: { name: 'Paraguayan Guarani', symbol: '₲' },
    QAR: { name: 'Qatari Rial', symbol: 'ر.ق' },
    RON: { name: 'Romanian Leu', symbol: 'lei' },
    RSD: { name: 'Serbian Dinar', symbol: 'дин.' },
    RUB: { name: 'Russian Ruble', symbol: '₽' },
    RWF: { name: 'Rwandan Franc', symbol: 'FRw' },
    SAR: { name: 'Saudi Riyal', symbol: 'ر.س' },
    SBD: { name: 'Solomon Islands Dollar', symbol: 'SI$' },
    SCR: { name: 'Seychellois Rupee', symbol: '₨' },
    SDG: { name: 'Sudanese Pound', symbol: 'ج.س.' },
    SEK: { name: 'Swedish Krona', symbol: 'kr' },
    SGD: { name: 'Singapore Dollar', symbol: 'S$' },
    SHP: { name: 'Saint Helena Pound', symbol: '£' },
    SLL: { name: 'Sierra Leonean Leone', symbol: 'Le' },
    SOS: { name: 'Somali Shilling', symbol: 'S' },
    SRD: { name: 'Surinamese Dollar', symbol: 'Sr$' },
    SSP: { name: 'South Sudanese Pound', symbol: '£' },
    STN: { name: 'São Tomé and Príncipe Dobra', symbol: 'Db' },
    SVC: { name: 'Salvadoran Colón', symbol: '₡' },
    SYP: { name: 'Syrian Pound', symbol: '£S' },
    SZL: { name: 'Swazi Lilangeni', symbol: 'L' },
    THB: { name: 'Thai Baht', symbol: '฿' },
    TJS: { name: 'Tajikistani Somoni', symbol: 'SM' },
    TMT: { name: 'Turkmenistani Manat', symbol: 'T' },
    TND: { name: 'Tunisian Dinar', symbol: 'د.ت' },
    TOP: { name: 'Tongan Paʻanga', symbol: 'T$' },
    TRY: { name: 'Turkish Lira', symbol: '₺' },
    TTD: { name: 'Trinidad and Tobago Dollar', symbol: 'TT$' },
    TWD: { name: 'New Taiwan Dollar', symbol: 'NT$' },
    TZS: { name: 'Tanzanian Shilling', symbol: 'TSh' },
    UAH: { name: 'Ukrainian Hryvnia', symbol: '₴' },
    UGX: { name: 'Ugandan Shilling', symbol: 'USh' },
    USD: { name: 'US Dollar', symbol: '$' },
    UYU: { name: 'Uruguayan Peso', symbol: '$U' },
    UZS: { name: 'Uzbekistan Som', symbol: 'сўм' },
    VES: { name: 'Venezuelan Bolívar', symbol: 'Bs.' },
    VND: { name: 'Vietnamese Dong', symbol: '₫' },
    VUV: { name: 'Vanuatu Vatu', symbol: 'VT' },
    WST: { name: 'Samoan Tala', symbol: 'WS$' },
    XAF: { name: 'CFA Franc BEAC', symbol: 'FCFA' },
    XCD: { name: 'East Caribbean Dollar', symbol: 'EC$' },
    XOF: { name: 'CFA Franc BCEAO', symbol: 'CFA' },
    XPF: { name: 'CFP Franc', symbol: '₣' },
    YER: { name: 'Yemeni Rial', symbol: '﷼' },
    ZAR: { name: 'South African Rand', symbol: 'R' },
    ZMW: { name: 'Zambian Kwacha', symbol: 'ZK' }
};

/**
 * Get all currencies supported by the currency-denominations package
 * combined with metadata (name and symbol)
 * @returns {Array<{code: string, name: string, symbol: string}>}
 */
export function getAllCurrencies() {
    const supportedCodes = getSupportedCurrencies();

    return supportedCodes
        .filter(code => CURRENCY_METADATA[code]) // Only include currencies with metadata
        .map(code => ({
            code,
            name: CURRENCY_METADATA[code].name,
            symbol: CURRENCY_METADATA[code].symbol
        }))
        .sort((a, b) => a.code.localeCompare(b.code));
}

/**
 * Get currency metadata by ISO code
 * @param {string} code - ISO 4217 currency code
 * @returns {{name: string, symbol: string} | null}
 */
export function getCurrencyByCode(code) {
    const metadata = CURRENCY_METADATA[code];
    if (!metadata) return null;

    return {
        code,
        name: metadata.name,
        symbol: metadata.symbol
    };
}

/**
 * Get currency symbol by ISO code
 * @param {string} code - ISO 4217 currency code
 * @returns {string}
 */
export function getCurrencySymbol(code) {
    const metadata = CURRENCY_METADATA[code];
    return metadata ? metadata.symbol : code;
}

export default {
    getAllCurrencies,
    getCurrencyByCode,
    getCurrencySymbol
};
